import HierarchicalObject from "./HierarchicalObject";


export default class TaggableData extends HierarchicalObject {

    constructor(data) {
        super();
        this._data = data;
        this.tags = data.tags || {};
        this.creationTime = data.creationTime || 0;
    }

    _data;

    creationTime;

    tags = {};

    get isEnabled() {
        return !(this.tags.IsEnabled === "false");
    }

    static checkTS(ts) {
        if (ts !== parseInt(ts)) return parseInt(ts + 978307200);
        return ts;
    }

    static isoDate(ts) {
        const date = new Date(this.checkTS(ts) * 1000);

        const YYYY = date.getFullYear();
        let MM = date.getMonth() + 1;
        let DD = date.getDate();

        if (MM.toString().length < 2) MM ='0' + MM;
        if (DD.toString().length < 2) DD ='0' + DD;

        return  `${YYYY}-${MM}-${DD}`;
    }

    static isoTime(ts) {
        const date = new Date(this.checkTS(ts) * 1000);

        let HH = date.getHours();
        let MM = date.getMinutes();
        let SS = date.getSeconds();

        if (HH.toString().length < 2) HH ='0' + HH;
        if (MM.toString().length < 2) MM ='0' + MM;
        if (SS.toString().length < 2) SS ='0' + SS;

        return  `${HH}:${MM}:${SS}`;
    }

    static isoNow() {
        const tsNow = parseInt((new Date()) / 1000);
        return this.isoDate(tsNow) + ', ' + this.isoTime(tsNow);
    }

    get isoDate() {
        return TaggableData.isoDate(this.creationTime);
    }

    get isoTime() {
        return TaggableData.isoTime(this.creationTime);
    }

    get isoDateTime() {
        return this.isoDate + ', ' + this.isoTime;
    }

}